import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImg2 from '../components/HeroImg2'
import ContactInfo from '../components/ContactInfo'

const Contact = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2 heading='CONTACT' text='Call or email us to discuss your project.' />
      <ContactInfo />
      <Footer />
    </div>
  )
}

export default Contact